import React from "react";

import "./styles.css";

//Components
import BlockTrack from "../../BlockTrack";

export default function MyTopNine() {
  return (
    <div>
      <BlockTrack />
    </div>
  );
}
